import { getListings, getCities, getListingCalendar, getSingleListing, postBooking } from 'listing/listing.service.js';
import isUndefined from 'lodash/isUndefined';
import getPaymentToken from 'services/stripe';

export const types = {
  "FETCH_LISTINGS"          : "FETCH_LISTINGS",
  "FETCH_CITIES"            : "FETCH_CITIES",
  "FETCH_LISTINGS_REQUEST"  : "FETCH_LISTINGS_REQUEST",
  "QUERY_CHANGE"            : "QUERY_CHANGE",
  "FETCH_LISTING_CALENDAR_REQUEST" : "FETCH_LISTING_CALENDAR_REQUEST",
  "FETCH_LISTING_CALENDAR"  : "FETCH_LISTING_CALENDAR",
  "SUBMIT_BOOKING"          : "SUBMIT_BOOKING",
  "SUBMIT_BOOKING_REQUEST"  : "SUBMIT_BOOKING_REQUEST",
  "FETCH_SINGLE_LISTING_REQUEST": "FETCH_SINGLE_LISTING_REQUEST",
  "FETCH_SINGLE_LISTING"    : "FETCH_SINGLE_LISTING",
  "UPDATE_ACTIVE_LISTING"   : "UPDATE_ACTIVE_LISTING",
  "RESET_BOOKING"           : "RESET_BOOKING"
};

const listingsAction = (listings, isSearch, initial) => ({
  type: types.FETCH_LISTINGS,
  listings,
  isSearch,
  initial
});

const listingRequestAction = ({ skip, isSearch, initial, isShowMore }) => ({
  type: types.FETCH_LISTINGS_REQUEST,
  skip,
  isSearch,
  initial,
  isShowMore
});

const citiesAction = (cities) => ({
  type: types.FETCH_CITIES,
  cities
});

const listingCalendarRequest = (listingId, from, to) => ({
  type: types.FETCH_LISTING_CALENDAR_REQUEST,
  listingId,
  from,
  to
});

const singleListingRequest = (listingId, from, to, initial) => ({
  type: types.FETCH_SINGLE_LISTING_REQUEST,
  listingId,
  from,
  to,
  initial
});

const listingCalendarAction = (listingId, calendar) => ({
  type: types.FETCH_LISTING_CALENDAR,
  listingId,
  calendar
});

const bookingSubmitRequest = () => ({
  type: types.SUBMIT_BOOKING_REQUEST
});

const singleListingAction = (listing, initial) => ({
  type: types.FETCH_SINGLE_LISTING,
  listing,
  initial
});

export const bookingSubmitAction = (result) => ({
  type: types.SUBMIT_BOOKING,
  result
});

export const updateActiveListing = (listingId) => ({
  type: types.UPDATE_ACTIVE_LISTING,
  listingId
});

export const queryChange = ({ city, startDate, endDate, guests }) => {
  const query = {};
  if (!isUndefined(city)) query.city = city;
  if (!isUndefined(startDate)) query.startDate = startDate;
  if (!isUndefined(endDate)) query.endDate = endDate;
  if (!isUndefined(guests)) query.guests = guests;

  return {
    type: types.QUERY_CHANGE,
    query
  };
};

export const resetBooking = () => ({
  type: types.RESET_BOOKING
});

export const fetchListings = (options = {}) => dispatch => {
  dispatch(listingRequestAction(options));

  return getListings(options)
    .then(listings => dispatch(listingsAction(listings, options.isSearch, options.initial)));
};

export const fetchCities = () => dispatch => getCities()
  .then(cities => dispatch(citiesAction(cities)));

export const fetchListingCalendar = (listingId, from, to) => dispatch => {
  dispatch(listingCalendarRequest(listingId, from, to));

  return getListingCalendar(listingId, from, to)
    .then(calendar => dispatch(listingCalendarAction(listingId, calendar)));
};

export const bookingSubmit = data => dispatch => {
    dispatch(bookingSubmitRequest());

    return postBooking(data)
      .then(result => dispatch(bookingSubmitAction(result)))
      .catch(err => dispatch(bookingSubmitAction({ err })));
};

export const getPaymentTokenAction = data => dispatch => {
  dispatch(bookingSubmitRequest());

  return getPaymentToken(data);
};

export const fetchSingleListing = (listingId, from, to, initial) => dispatch => {
  dispatch(singleListingRequest(listingId, from, to, initial));

  return getSingleListing(listingId, from, to)
    .then(listing => dispatch(singleListingAction(listing, initial)));
};


// WEBPACK FOOTER //
// ./src/listing/listing.actions.js